import { useUiStore } from '../../store/uiStore';
import { useAuthStore } from '../../lib/auth';
import { useTicketStore } from '../../store/ticketStore';
import { useTickets } from '../../hooks/useTickets';

export default function TopBar() {
  const activeView   = useUiStore(s => s.activeView);
  const openModal    = useUiStore(s => s.openModal);
  const { user }     = useAuthStore();
  const isLoading    = useTicketStore(s => s.isLoading);
  const version      = useTicketStore(s => s.version);
  const { fetchData } = useTickets();

  return (
    <header className="header" role="banner">
      <div className="page-title">
        <h1>IT Command Center</h1>
        <p className="header-subtitle">
          Live Metrics • Version Polling Enabled • Combined Update 🎯
        </p>
      </div>
      <div className="header-actions">
        {/* Notification button */}
        <button className="btn header-icon-btn" title="Notifications">🔔</button>
        {/* Keyboard shortcuts */}
        <button className="btn header-icon-btn" title="Keyboard Shortcuts">⌨️</button>
        {/* Create ticket */}
        <button
          id="header-create-ticket-btn"
          className="btn btn-create"
          onClick={() => openModal('createTicket')}
        >
          ➕ Create Ticket
        </button>
        {/* Refresh */}
        <button
          id="header-refresh-btn"
          className="btn btn-primary"
          onClick={() => fetchData()}
          disabled={isLoading}
        >
          <span className={isLoading ? 'spinning' : ''} aria-hidden="true">🔄</span>
          {' '}Refresh
        </button>
      </div>
    </header>
  );
}
